// src/services/lead.service.js

export const saveLead = async (leadData) => {
  try {
    const baseUrl = process.env.REACT_APP_API_URL; // ejemplo: http://measures.somee.com/api
    const url = `${baseUrl}/Lead/SaveLead`;

    console.log("✅ POST URL:", url);
    console.log("✅ Payload:", leadData);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(leadData),
    });

    const text = await response.text(); // importante: primero texto
    console.log("✅ HTTP Status:", response.status);
    console.log("✅ Raw response:", text);

    // Intentar parsear JSON si aplica
    let result = null;
    try {
      result = text ? JSON.parse(text) : null;
    } catch {
      result = { success: 0, message: text || "Respuesta no JSON del servidor.", data: false };
    }

    // Si status no es 2xx, devolver error controlado
    if (!response.ok) {
      return {
        success: 0,
        message: result?.message || `Error HTTP ${response.status}`,
        data: result?.data ?? false,
      };
    }

    return result;
  } catch (error) {
    console.error("❌ Error al guardar Lead:", error);
    return {
      success: 0,
      message: "Error de conexión con el servidor.",
      data: false,
    };
  }
};